// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sCaW","top":"styles_top__2kapT","left":"styles_left__3YiG8","description":"styles_description__2oz47"};